import React, { useState, useEffect, useRef } from "react";
import { instance2 } from "../utils/axiosInstance";
import DatePicker from "react-datepicker";
import { useNavigate, useLocation } from "react-router-dom";
import CalendarIcon from "../img/calendaricon.svg";
import { ReactComponent as BackButton } from "../img/bacbuttonicon.svg";
import { formatNumber } from "../numberingformat";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import DapurIcon from "../img/logodapursidebar.png";
import BgnIcon from "../img/logobgn250.png";
import { basecode } from "../mainscreen/pesananscreen/baserobotocode";
import { basecodeBold } from "./pesananscreen/baserobotoboldcode";

export default function DetailProduksiHarian() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(null); // Load only if editing
  const [error, setError] = useState(null);
  const [dataIngredient, setDataIngredient] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const startDate = queryParams.get("date");
  const kitchenIdKoperasi = queryParams.get("kitchenId");
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(
    startDate ? new Date(startDate) : new Date(),
  );

  const kitchenId = localStorage?.getItem("kitchenId");
  const storedLocationId = localStorage.getItem("locationId");
  const storedKitchenName = localStorage.getItem("kitchenname");
  const storedLocationName = localStorage.getItem("locationname");

  const [kitchenName, setKitchenName] = useState(storedKitchenName || "");
  const [locationName, setLocationName] = useState(storedLocationName || "");

  const [dataMenu, setDataMenu] = useState([]);
  const [dataHarian, setDataHarian] = useState([]);

  useEffect(() => {
    const fetchKitchenName = async () => {
      if (!storedKitchenName && kitchenIdKoperasi && storedLocationId) {
        try {
          const response = await instance2.get("/kitchen");
          const kitchens = response.data;

          const matched = kitchens.find(
            (k) =>
              String(k.kitchen_id) === String(kitchenIdKoperasi) &&
              String(k.location_id) === String(storedLocationId),
          );

          if (matched) {
            setKitchenName(matched.kitchen_name);
            localStorage.setItem("kitchenname", matched.kitchen_name); // optional
          }
        } catch (err) {
          console.error("Failed to fetch kitchen:", err);
        }
      }
    };

    fetchKitchenName();
  }, [storedKitchenName, kitchenIdKoperasi, storedLocationId]);

  useEffect(() => {
    const fetchDataMenu = async () => {
      try {
        setLoading(true);
        const response = await instance2.get(
          `/menu_schedule/kitchen/${
            kitchenId || kitchenIdKoperasi
          }/${localDateString(selectedDate)}/${localDateString(selectedDate)}`,
        );
        setDataMenu(response.data[0]); // Store API data
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchDataMenu();
  }, [selectedDate, kitchenId, kitchenIdKoperasi]);

  useEffect(() => {
    const fetchDataHarian = async () => {
      try {
        setLoading(true);
        const response = await instance2.get(
          `/customers/kitchen_sum/${
            kitchenId || kitchenIdKoperasi
          }/${localDateString(selectedDate)}`,
        );
        setDataHarian(response.data); // Store API data
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchDataHarian();
  }, [selectedDate, kitchenId, kitchenIdKoperasi]);

  const localDateString = (thedate) => {
    const year = thedate.getFullYear();
    const month = String(thedate.getMonth() + 1).padStart(2, "0");
    const day = String(thedate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const CustomInput = React.forwardRef(({ value, onClick, isOpen }, ref) => (
    <button
      className={`flex items-center justify-between w-full px-4 py-3 border rounded-full bg-gray-100 cursor-not-allowed`}
      onClick={onClick}
      ref={ref}
      type="button"
      disabled
    >
      <div className="flex items-center gap-2">
        <img
          src={CalendarIcon}
          alt="Calendar"
          className="h-5 w-5 text-gray-500"
        />
        <div className="w-px h-5 bg-gray-300 mx-1 me-3"></div>
        <span>
          {new Date(value).toLocaleDateString("id-ID", {
            year: "numeric",
            month: "long",
            day: "2-digit",
          })}
        </span>
      </div>
      <div
        className={`text-black font-semibold transform transition-transform ${
          isOpen ? "rotate-180" : "rotate-0"
        }`}
      >
        ▼
      </div>
    </button>
  ));

  const generatePDFCluster = async (item, clusterName, orderDate) => {
    const doc = new jsPDF();
    const kitchenName = localStorage.getItem("kitchenname") || "Dapur";

    // Embed Roboto font
    doc.addFileToVFS("Roboto-Regular.ttf", basecode);
    doc.addFileToVFS("Roboto-Bold.ttf", basecodeBold);
    doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
    doc.addFont("Roboto-Bold.ttf", "Roboto", "bold");
    doc.setFont("Roboto", "normal");

    // Load icon as base64
    const loadImageAsBase64 = (imgSrc) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = imgSrc;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        };
        img.onerror = (err) => reject(err);
      });

    const iconBase64 = await loadImageAsBase64(BgnIcon);
    const pageWidth = doc.internal.pageSize.width;
    const LEFT_MARGIN = 30;
    const RIGHT_MARGIN = 20;

    // Header function
    const addHeader = (doc, pageWidth, orderDate, kitchenName, schoolName) => {
      const textYOffset = 10;

      // Icon on the LEFT
      const iconWidth = 23;
      const iconHeight = 23;
      const iconX = LEFT_MARGIN;
      const iconY = textYOffset + 2;
      doc.addImage(iconBase64, "PNG", iconX, iconY, iconWidth, iconHeight);

      doc.setFontSize(12);
      doc.setFont("Roboto", "bold");
      doc.setTextColor(59, 78, 135);
      doc.text("LAPORAN PRODUKSI", LEFT_MARGIN, textYOffset + 19 + iconHeight, {
        align: "left",
      });
      doc.setTextColor(0, 0, 0);

      // Date box on the right
      const boxWidth = 60;
      const boxHeight = 6;
      const blockX = pageWidth - boxWidth - RIGHT_MARGIN;

      doc.setFontSize(10);
      doc.setFont("Roboto", "normal");
      doc.text("TANGGAL", blockX - 19, textYOffset + 18 + iconHeight);

      const dateValue = new Date(orderDate).toLocaleDateString("id-ID", {
        year: "numeric",
        month: "long",
        day: "2-digit",
      });

      const boxY = textYOffset + 14 + iconHeight;
      doc.setDrawColor(150, 150, 150);
      doc.setLineWidth(0.2);
      doc.rect(blockX, boxY, boxWidth, boxHeight);

      const dateTextWidth = doc.getTextWidth(dateValue);
      const dateTextX = blockX + (boxWidth - dateTextWidth) / 2;
      doc.text(dateValue, dateTextX, boxY + 4);

      const alamatLines = [
        "Kompleks Kementerian Pertanian",
        "Jl Harsono RM No.3 Gedung E",
        "Ragunan, Ps. Minggu, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12550",
      ];
      const linkBgn = "https://www.bgn.go.id/";
      const textWidthLinkBgn = doc.getTextWidth(linkBgn);

      const startX = LEFT_MARGIN + iconWidth + 6;
      let startY = textYOffset + iconHeight / 2 - 4;

      // Loop through the lines and print them in a column
      alamatLines.forEach((line) => {
        doc.setFontSize(8);
        doc.text(line, startX, startY);
        startY += 4; // move down for the next line
      });

      // Draw link on top
      doc.setTextColor(0, 120, 255);
      doc.textWithLink(linkBgn, startX, startY, { url: linkBgn });

      // Underline
      doc.setDrawColor(0, 120, 255);
      doc.line(startX, startY + 1, startX + textWidthLinkBgn - 6, startY + 1);

      // Reset color
      doc.setTextColor(0, 0, 0);
      doc.setDrawColor(0, 0, 0);

      // Info section
      const margin = 14;
      const rowHeight = 8;
      const colWidth = (pageWidth - (LEFT_MARGIN + RIGHT_MARGIN + margin)) / 2; // Two columns
      const startYInfo = 60;
      const RECT_PADDING = 4;

      // Dapur column
      doc.setFillColor(59, 78, 135);
      doc.rect(LEFT_MARGIN, startYInfo, colWidth, rowHeight, "F");
      doc.setFontSize(10);
      doc.setTextColor(255, 255, 255);
      doc.setFont("Roboto", "bold");
      doc.text("DAPUR", LEFT_MARGIN + RECT_PADDING, startYInfo + 5.5);
      doc.setTextColor(0, 0, 0);
      doc.setFont("Roboto", "normal");
      doc.setFontSize(10);
      doc.text(
        kitchenName,
        LEFT_MARGIN + RECT_PADDING,
        startYInfo + rowHeight + 6,
      );

      // Sekolah Penerima column
      const secondColX = LEFT_MARGIN + colWidth + margin;
      doc.setFillColor(59, 78, 135);
      doc.rect(secondColX, startYInfo, colWidth, rowHeight, "F");
      doc.setFontSize(10);
      doc.setTextColor(255, 255, 255);
      doc.setFont("Roboto", "bold");
      doc.text("CLUSTER", secondColX + RECT_PADDING, startYInfo + 5.5);
      doc.setTextColor(0, 0, 0);
      doc.setFont("Roboto", "normal");
      doc.setFontSize(10);
      doc.text(
        schoolName,
        secondColX + RECT_PADDING,
        startYInfo + rowHeight + 6,
      );

      return startYInfo + rowHeight + 18;
    };

    let yOffset = addHeader(
      doc,
      pageWidth,
      orderDate,
      kitchenName,
      clusterName,
    );

    // Menu Section
    doc.setFontSize(10);
    doc.setFont("Roboto", "bold");
    doc.setTextColor(59, 78, 135);
    doc.text("MENU", LEFT_MARGIN, yOffset);
    yOffset += 3;

    const menuItems = [
      ["Karbohidrat", dataMenu?.KARBOHIDRAT || "-"],
      ["Protein", dataMenu?.PROTEIN || "-"],
      ["Sayuran", dataMenu?.SAYURAN || "-"],
      ["Buah", dataMenu?.BUAH || "-"],
      ["Minuman", dataMenu?.MINUMAN || "-"],
    ];

    doc.autoTable({
      theme: "grid",
      startY: yOffset,
      body: menuItems,
      margin: { left: LEFT_MARGIN, right: RIGHT_MARGIN },
      styles: { fontSize: 10, font: "Roboto", lineColor: [0, 0, 0] },
      columnStyles: { 0: { fontStyle: "bold" } },
    });

    yOffset = doc.lastAutoTable.finalY + 10;

    // Realisasi Table
    doc.autoTable({
      startY: yOffset,
      theme: "grid",
      head: [["Keterangan", "Jumlah"]],
      body: [["Realisasi", `${formatNumber(item.total_qty ?? 0)} Porsi`]],
      margin: { left: LEFT_MARGIN, right: RIGHT_MARGIN },
      styles: {
        cellPadding: 1.5,
        fontSize: 10,
        font: "Roboto",
        lineWidth: 0.2,
        lineColor: [0, 0, 0],
      },
      headStyles: {
        fontSize: 10,
        fontStyle: "bold",
        fillColor: [59, 78, 135],
        textColor: [255, 255, 255],
      },
    });

    yOffset = doc.lastAutoTable.finalY + 30;

    // Signature Block
    const signatureX1 = LEFT_MARGIN;

    doc.setFontSize(10);
    doc.setFont("Roboto", "normal");
    doc.setTextColor(0, 0, 0);

    // Pihak Dapur
    doc.text("Pihak Penerima", signatureX1, yOffset);
    doc.line(signatureX1, yOffset + 25, signatureX1 + 60, yOffset + 25);
    doc.text("Nama:", signatureX1, yOffset + 35);
    doc.text("Jabatan:", signatureX1, yOffset + 42);
    doc.text("Jam Terima:", signatureX1, yOffset + 49);

    doc.save(`Laporan_${clusterName}.pdf`);
  };

  const handleDownloadPagePDF = async () => {
    const doc = new jsPDF();
    const dateStr = localDateString(selectedDate);
    const kitchenName = localStorage.getItem("kitchenname") || "Dapur";

    // Embed Roboto font
    doc.addFileToVFS("Roboto-Regular.ttf", basecode);
    doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
    doc.addFont("Roboto-Regular.ttf", "Roboto", "bold");
    doc.setFont("Roboto", "normal");

    // Load icon as base64
    const loadImageAsBase64 = (imgSrc) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = imgSrc;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        };
        img.onerror = (err) => reject(err);
      });

    const iconBase64 = await loadImageAsBase64(BgnIcon);
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const LEFT_MARGIN = 30;
    const RIGHT_MARGIN = 20;

    // Header function
    const addHeader = (doc, pageWidth, orderDate, kitchenName) => {
      const textYOffset = 10;

      // Icon on the LEFT
      const iconWidth = 23;
      const iconHeight = 23;
      const iconX = LEFT_MARGIN;
      const iconY = textYOffset + 2;
      doc.addImage(iconBase64, "PNG", iconX, iconY, iconWidth, iconHeight);

      doc.setFontSize(12);
      doc.setFont("Roboto", "bold");
      doc.setTextColor(59, 78, 135);
      doc.text("LAPORAN PRODUKSI", LEFT_MARGIN, textYOffset + 19 + iconHeight, {
        align: "left",
      });
      doc.setTextColor(0, 0, 0);

      // Date box on the right
      const boxWidth = 60;
      const boxHeight = 6;
      const blockX = pageWidth - boxWidth - RIGHT_MARGIN;

      doc.setFontSize(10);
      doc.setFont("Roboto", "normal");
      doc.text("TANGGAL", blockX - 19, textYOffset + 18 + iconHeight);

      const dateValue = new Date(orderDate).toLocaleDateString("id-ID", {
        year: "numeric",
        month: "long",
        day: "2-digit",
      });

      const boxY = textYOffset + 14 + iconHeight;
      doc.setDrawColor(150, 150, 150);
      doc.setLineWidth(0.2);
      doc.rect(blockX, boxY, boxWidth, boxHeight);

      const dateTextWidth = doc.getTextWidth(dateValue);
      const dateTextX = blockX + (boxWidth - dateTextWidth) / 2;
      doc.text(dateValue, dateTextX, boxY + 4);

      const alamatLines = [
        "Kompleks Kementerian Pertanian",
        "Jl Harsono RM No.3 Gedung E",
        "Ragunan, Ps. Minggu, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12550",
      ];
      const linkBgn = "https://www.bgn.go.id/";
      const textWidthLinkBgn = doc.getTextWidth(linkBgn);

      const startX = LEFT_MARGIN + iconWidth + 6;
      let startY = textYOffset + iconHeight / 2 - 4;

      // Loop through the lines and print them in a column
      alamatLines.forEach((line) => {
        doc.setFontSize(8);
        doc.text(line, startX, startY);
        startY += 4; // move down for the next line
      });

      // Draw link on top
      doc.setTextColor(0, 120, 255);
      doc.textWithLink(linkBgn, startX, startY, { url: linkBgn });

      // Underline
      doc.setDrawColor(0, 120, 255);
      doc.line(startX, startY + 1, startX + textWidthLinkBgn - 6, startY + 1);

      // Reset color
      doc.setTextColor(0, 0, 0);
      doc.setDrawColor(0, 0, 0);

      // Info section
      const rowHeight = 8;
      const colWidth = pageWidth - (LEFT_MARGIN + RIGHT_MARGIN); // Full width for the Dapur section
      const startYInfo = 60;
      const RECT_PADDING = 4;

      // Dapur column
      doc.setFillColor(59, 78, 135);
      doc.rect(LEFT_MARGIN, startYInfo, colWidth, rowHeight, "F");
      doc.setFontSize(10);
      doc.setTextColor(255, 255, 255);
      doc.setFont("Roboto", "bold");
      doc.text("DAPUR", LEFT_MARGIN + RECT_PADDING, startYInfo + 5.5);
      doc.setTextColor(0, 0, 0);
      doc.setFont("Roboto", "normal");
      doc.setFontSize(10);
      doc.text(
        kitchenName,
        LEFT_MARGIN + RECT_PADDING,
        startYInfo + rowHeight + 6,
      );

      return startYInfo + rowHeight + 18;
    };

    // Add header to first page
    let yOffset = addHeader(doc, pageWidth, dateStr, kitchenName);

    // Add Menu Section
    doc.setFontSize(10);
    doc.setFont("Roboto", "bold");
    doc.setTextColor(59, 78, 135);
    doc.text("MENU", LEFT_MARGIN, yOffset);
    yOffset += 3;

    const menuItems = [
      ["Karbohidrat", dataMenu?.KARBOHIDRAT || "-"],
      ["Protein", dataMenu?.PROTEIN || "-"],
      ["Sayuran", dataMenu?.SAYURAN || "-"],
      ["Buah", dataMenu?.BUAH || "-"],
      ["Minuman", dataMenu?.MINUMAN || "-"],
    ];

    doc.autoTable({
      theme: "grid",
      startY: yOffset,
      body: menuItems,
      margin: { left: LEFT_MARGIN, right: RIGHT_MARGIN },
      styles: { fontSize: 10, font: "Roboto", lineColor: [0, 0, 0] },
      columnStyles: { 0: { fontStyle: "bold" } },
    });

    yOffset = doc.lastAutoTable.finalY + 10;

    const pagiItems = dataHarian.filter(
      (item) => item.delivery === "PAGI" && item.cluster_name,
    );
    const siangItems = dataHarian.filter((item) => item.delivery === "SIANG");
    let grandTotal = 0;
    const margin = 14;

    const renderSection = (title, items, startX, tableWidth) => {
      if (items.length === 0) return;

      doc.setFontSize(12);
      doc.setFont("Roboto", "bold");
      doc.text(title, startX, yOffset);

      const sectionTotal = items.reduce(
        (sum, item) => sum + Number(item.total_qty || 0),
        0,
      );
      grandTotal += sectionTotal;

      doc.autoTable({
        startY: yOffset + 8,
        head: [["Cluster", "Jumlah Porsi"]],
        body: items.map((item) => [
          item.cluster_name,
          formatNumber(Number(item.total_qty)),
        ]),
        styles: {
          cellPadding: 1.5,
          fontSize: 9,
          font: "Roboto",
          lineWidth: 0.2,
          lineColor: [0, 0, 0],
        },
        headStyles: {
          fontSize: 10,
          fontStyle: "bold",
          fillColor: [59, 78, 135],
          textColor: [255, 255, 255],
        },
        margin: { left: startX },
        tableWidth: tableWidth,
      });

      const finalY = doc.lastAutoTable.finalY;

      doc.setFontSize(9);
      doc.setFont("Roboto", "bold");
      doc.text(`Total Porsi ${title}:`, startX, finalY + 6);
      doc.text(
        formatNumber(sectionTotal),
        startX + tableWidth - doc.getTextWidth(formatNumber(sectionTotal)),
        finalY + 6,
      );

      return finalY + 12;
    };

    const tableWidth = (pageWidth - (LEFT_MARGIN + RIGHT_MARGIN + margin)) / 2;
    const pagiY = renderSection("PAGI", pagiItems, LEFT_MARGIN, tableWidth);
    const siangY = renderSection(
      "SIANG",
      siangItems,
      LEFT_MARGIN + tableWidth + margin,
      tableWidth,
    );

    yOffset = Math.max(pagiY || yOffset, siangY || yOffset);

    doc.setFontSize(10);
    doc.setFont("Roboto", "bold");
    doc.text("Total Produksi Keseluruhan:", LEFT_MARGIN, yOffset + 6);
    doc.text(
      formatNumber(grandTotal),
      pageWidth - RIGHT_MARGIN - doc.getTextWidth(formatNumber(grandTotal)),
      yOffset + 6,
    );
    yOffset += 15;

    const signatureX = pageWidth - (LEFT_MARGIN + RIGHT_MARGIN + margin);
    if (yOffset + 40 > pageHeight - 20) {
      doc.addPage();
      yOffset = addHeader(doc, pageWidth, dateStr, kitchenName);
    }
    doc.setFont("Roboto", "normal");
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.text("Disetujui oleh,", signatureX, yOffset + 10);
    doc.text("Jabatan", signatureX, yOffset + 35);

    doc.save(`Laporan_Produksi_${dateStr}.pdf`);
  };

  const getTotalQty = () => {
    return dataHarian.reduce(
      (sum, item) => sum + Number(item.total_qty || 0),
      0,
    );
  };

  return (
    <div className="p-4">
      {/* Back Button & Header */}
      <div className="flex flex-row gap-4 items-center">
        <div
          className="bg-white p-2 rounded-full cursor-pointer"
          onClick={() => navigate(-1)}
        >
          <BackButton className="rotate-180 text-black" />
        </div>
        <h1 className="text-xl sm:text-2xl font-medium">
          {"Detail Produksi Harian"}
        </h1>
      </div>

      {/* Loading & Error Handling */}
      {loading ? (
        <div className="px-4 py-8 flex justify-center">
          <div className="w-6 h-6 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
        </div>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <div className="py-5">
          {/* Form Section */}
          <div className="flex flex-col gap-6 lg:flex-row justify-between items-start">
            {/* Left Column */}
            <div className="flex flex-col gap-4 w-full lg:w-1/2">
              {/* Date Picker */}
              <div className="flex flex-col sm:flex-row gap-4 items-center">
                <label className="block text-gray-700 w-full sm:w-1/4 text-sm">
                  Tanggal
                </label>
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  customInput={
                    <CustomInput
                      value={selectedDate.toLocaleDateString("id-ID", {
                        year: "numeric",
                        month: "long",
                        day: "2-digit",
                      })}
                      isOpen={isOpen}
                    />
                  }
                  onCalendarOpen={() => setIsOpen(true)}
                  onCalendarClose={() => setIsOpen(false)}
                  dateFormat="yyyy-MM-dd"
                  disabled
                />
              </div>

              {/* Kitchen Name */}
              <div className="flex flex-col sm:flex-row gap-4 items-center">
                <label className="block text-gray-700 w-full sm:w-1/4 text-sm">
                  Nama Dapur
                </label>
                <input
                  type="text"
                  name="name"
                  value={kitchenName}
                  className="w-full px-3 border border-gray-300 rounded-lg text-xs py-2 bg-gray-100"
                  disabled
                />
              </div>

              {/* Cooperative Name */}
              <div className="flex flex-col sm:flex-row gap-4 items-center">
                <label className="block text-gray-700 w-full sm:w-1/4 text-sm">
                  Koperasi
                </label>
                <input
                  type="text"
                  name="description"
                  value={locationName}
                  className="w-full px-3 border border-gray-300 rounded-lg text-xs py-2 bg-gray-100"
                  disabled
                />
              </div>
            </div>

            {/* Right Column: Menu Schedule */}
            <div className="w-full lg:w-1/2 border border-black rounded-lg p-4">
              <div className="text-center font-semibold text-sm mb-2">
                Menu Hari Ini
              </div>
              {dataMenu ? (
                <div className="flex flex-col gap-2 text-center text-sm text-gray-700">
                  <div>{dataMenu.KARBOHIDRAT}</div>
                  <div>{dataMenu.PROTEIN}</div>
                  <div>{dataMenu.SAYURAN}</div>
                  <div>{dataMenu.BUAH}</div>
                  <div>{dataMenu.MINUMAN}</div>
                </div>
              ) : (
                <div className="text-center text-sm text-gray-500">
                  Belum ada data
                </div>
              )}
            </div>
          </div>

          {/* Table for Customer Data */}
          <div className="mt-6 w-full items-center text-center justify-between">
            <h2 className="text-lg font-semibold mb-2">Realisasi</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Pagi Table */}
              <div className="flex flex-col gap-4">
                <h3 className="font-semibold">Pagi</h3>
                <table className="table-fixed border-gray-300 mx-auto w-full h-full">
                  <thead className="bg-white">
                    <tr className="text-left text-sm text-gray-700">
                      <th className="border-b border-gray-300 px-4 py-2 rounded-tl-[15px] text-left text-xxs md:text-xxs lg:text-base">
                        Cluster
                      </th>
                      <th className="border-b border-gray-300 px-4 py-2 text-right text-xxs md:text-xxs lg:text-base">
                        Jumlah Porsi
                      </th>
                      <th className="border-b border-gray-300 px-4 py-2 rounded-tr-[15px] text-center text-xxs md:text-xxs lg:text-base">
                        Download
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataHarian
                      .filter((item) => item.delivery === "PAGI")
                      .map((item, index) => (
                        <tr
                          key={index}
                          className={
                            index % 2 === 0 ? "bg-transparent" : "bg-white"
                          }
                        >
                          <td className="px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
                            {item.cluster_name}
                          </td>
                          <td className="px-4 py-2 text-right pe-7 text-xxs md:text-xxs lg:text-base">
                            {formatNumber(item.total_qty)}
                          </td>
                          <td className="px-4 py-2 text-center">
                            <button
                              className="bg-blue-500 text-white px-2 py-1 rounded text-xs hover:bg-blue-600"
                              onClick={() =>
                                generatePDFCluster(
                                  item,
                                  item.cluster_name,
                                  localDateString(selectedDate),
                                )
                              }
                            >
                              Download PDF
                            </button>
                          </td>
                        </tr>
                      ))}
                    <tr>
                      <td className="font-bold px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
                        Total Pagi
                      </td>
                      <td className="font-bold px-4 py-2 text-right pe-7 text-xxs md:text-xxs lg:text-base">
                        {formatNumber(
                          getTotalQty(
                            dataHarian.filter(
                              (item) => item.delivery === "PAGI",
                            ),
                          ),
                        )}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Siang Table */}
              <div className="flex flex-col gap-4">
                <h3 className="font-semibold">Siang</h3>
                <table className="table-fixed border-gray-300 mx-auto w-full h-full">
                  <thead className="bg-white">
                    <tr className="text-left text-sm text-gray-700">
                      <th className="border-b border-gray-300 px-4 py-2 rounded-tl-[15px] text-left text-xxs md:text-xxs lg:text-base">
                        Cluster
                      </th>
                      <th className="border-b border-gray-300 px-4 py-2 text-right text-xxs md:text-xxs lg:text-base">
                        Jumlah Porsi
                      </th>
                      <th className="border-b border-gray-300 px-4 py-2 rounded-tr-[15px] text-center text-xxs md:text-xxs lg:text-base">
                        Download
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataHarian
                      .filter((item) => item.delivery === "SIANG")
                      .map((item, index) => (
                        <tr
                          key={index}
                          className={
                            index % 2 === 0 ? "bg-transparent" : "bg-white"
                          }
                        >
                          <td className="px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
                            {item.cluster_name}
                          </td>
                          <td className="px-4 py-2 text-right pe-7 text-xxs md:text-xxs lg:text-base">
                            {formatNumber(item.total_qty)}
                          </td>
                          <td className="px-4 py-2 text-center">
                            <button
                              className="bg-blue-500 text-white px-2 py-1 rounded text-xs hover:bg-blue-600"
                              onClick={() =>
                                generatePDFCluster(
                                  item,
                                  item.cluster_name,
                                  localDateString(selectedDate),
                                )
                              }
                            >
                              Download PDF
                            </button>
                          </td>
                        </tr>
                      ))}
                    <tr>
                      <td className="font-bold px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
                        Total Siang
                      </td>
                      <td className="font-bold px-4 py-2 text-right pe-7 text-xxs md:text-xxs lg:text-base">
                        {formatNumber(
                          getTotalQty(
                            dataHarian.filter(
                              (item) => item.delivery === "SIANG",
                            ),
                          ),
                        )}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-center mt-6 gap-5">
            <button
              className="bg-merah-no text-white py-3 px-6 rounded-lg hover:bg-merah-hover text-xxs md:text-xxs lg:text-base"
              onClick={() => navigate(-1)}
            >
              Kembali
            </button>
            <button
              className="bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-lg text-xxs md:text-xxs lg:text-base"
              onClick={handleDownloadPagePDF}
            >
              Download Halaman PDF
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
